import React, { useState } from "react";
import { HandHeart, Check, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useApp } from "@/context/AppContext";
import { createServiceRequest, formatApiError } from "@/lib/api";
import AuthDialog from "@/components/AuthDialog";

// Logged-in shoppers can tell nearby vendors "Yeh service chahiye" for an empty search.
export function RequestServiceButton({ term, pincode }) {
  const { user } = useApp();
  const [state, setState] = useState("idle");
  const [authOpen, setAuthOpen] = useState(false);
  const send = async () => {
    if (!user) { setAuthOpen(true); return; }
    if (!/^\d{6}$/.test(pincode || "")) { toast.info("Pehle upar header mein apna PIN chunein, phir request bhejein."); return; }
    setState("busy");
    try {
      const r = await createServiceRequest(term, pincode);
      setState("done");
      toast.success(r.duplicate ? "Aapki request pehle se darj hai." : "Request bhej di! Aas-paas ke vendors ko yeh demand dikhegi.");
    } catch (e) { setState("idle"); toast.error(formatApiError(e)); }
  };
  return (
    <div className="mt-6" data-testid="request-service-box">
      {state === "done" ? (
        <div className="inline-flex items-center gap-1.5 text-sm font-semibold text-emerald-800" data-testid="request-service-done"><Check className="w-4 h-4" /> Request darj ho gayi — PIN {pincode}</div>
      ) : (
        <button onClick={send} disabled={state === "busy"} aria-busy={state === "busy"} className="inline-flex items-center gap-2 rounded-full bg-emerald-700 hover:bg-emerald-800 text-white px-5 py-2.5 text-sm font-semibold min-h-[44px] disabled:opacity-60" data-testid="request-service-btn">
          {state === "busy" ? <Loader2 className="w-4 h-4 animate-spin" /> : <HandHeart className="w-4 h-4" />} Yeh service chahiye
        </button>
      )}
      <p className="text-[11px] text-slate-400 mt-2 max-w-xs mx-auto">Sirf "{term}" aur aapka PIN vendors ko gintee ke roop mein dikhega — aapka naam ya number nahi.</p>
      <AuthDialog open={authOpen} onOpenChange={setAuthOpen} />
    </div>
  );
}
